import React from 'react';
import ReportCard from '../components/ReportCard';
import { barLength, fmtCount, fmtPct, niceCeil, rankByPrevalence, tip } from '../format';

/**
 * Overall prevalence of each deficiency, ranked. One amber bar per marker — a single semantic colour,
 * because this chart compares magnitudes rather than severities.
 */
const DeficiencyPrevalence = ({ data }) => {
  const ranked = rankByPrevalence(data.markers);
  const axisMax = niceCeil(ranked.length ? ranked[0].prevalence : 0);

  return (
    <ReportCard fileName='deficiency-prevalence' className='mt-ds-9 p-[30px]'>
      <h3 className='m-0 font-fig-extrabold text-[28px] font-bold leading-[1.18] text-gray-900'>
        {ranked.length ? `${ranked[0].label} leads the list` : 'Prevalence'}
      </h3>
      <p className='mb-ds-2 mt-[6px] text-[14px] text-gray-600'>
        Overall prevalence of each abnormality across the workforce
      </p>

      <div className='grid'>
        {ranked.map((marker, index) => (
          <div
            key={marker.key}
            className={`grid items-center gap-[22px] border-t border-gray-300 py-ds-5 ${
              index === ranked.length - 1 ? 'border-b' : ''
            }`}
            style={{ gridTemplateColumns: '170px 1fr 150px' }}
          >
            <div className='text-[17px] font-semibold text-gray-900'>{marker.label}</div>
            <div className='rounded-ds-pill bg-gray-200' style={{ height: 18 }}>
              <div
                data-tip={tip(
                  `${marker.label} · ${fmtPct(marker.prevalence)} of those tested`,
                  `${fmtCount(marker.affected)} employees affected`
                )}
                className='h-full rounded-ds-pill bg-ds-amber'
                style={{ width: `${barLength(marker.prevalence, axisMax)}%` }}
              />
            </div>
            <div className='text-right'>
              <span className='font-jetbrains-mono text-[22px] font-semibold tabular-nums text-gray-900'>
                {fmtPct(marker.prevalence)}
              </span>
              <small className='mt-[3px] block text-ts-xs text-gray-600'>
                {`${fmtCount(marker.affected)} employees affected`}
              </small>
            </div>
          </div>
        ))}
      </div>
    </ReportCard>
  );
};

export default DeficiencyPrevalence;
